module.exports = __webpack_public_path__ + "img/logo33.89044958.png";